import {_utils, viewportChecker} from "../utils/_utils.js";
import {_state} from "../state/state.js";

export const header = () => {
    return new Promise((resolve, reject) => {
        _utils.initSection('#header', (section, sectionIndex) => init(section, sectionIndex));
        resolve();
    })
}

const init = (header) => {
    stickyHeader(header);
    burgerMenu(header);
    mobileMenuDropdown();
    // mobileMenuLinks();
}

// Toggle `.is-scrolled` once the page leaves the very top. Light headers then flip
// to the dark-on-white look; dark headers already carry the white background.
const stickyHeader = (header) => {
    const THRESHOLD = 10;
    const onScroll = () => {
        header.classList.toggle('is-scrolled', window.scrollY > THRESHOLD);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {passive: true});
}

const burgerMenu = (header) => {
    const burgerBtn = header.querySelector('.header__burger');
    const burgerMenu = document.querySelector('#header-mobile-menu');
    if(burgerBtn){
        const toggleBurgerMenu = () => {
            console.log('toogle burger')
            if(_state.isActiveBurgerMenu){
                document.documentElement.classList.add("overflow-hidden");
                document.body.classList.add("overflow-hidden");
                burgerBtn.classList.add('active');
                burgerMenu.classList.add('open');
                header.classList.add('menu-opened');
            } else {
                burgerBtn.classList.remove('active');
                burgerMenu.classList.remove('open');
                header.classList.remove('menu-opened');
                document.documentElement.classList.remove("overflow-hidden");
                document.body.classList.remove("overflow-hidden");
            }
        }

        window.addEventListener('isActiveBurgerMenuChanged', () => {
            toggleBurgerMenu();
        })

        _state.updateState({isActiveBurgerMenu: burgerBtn.classList.contains('active') && !_state.isDesktop});
        toggleBurgerMenu();
        burgerBtn.addEventListener('click', e => {
            e.preventDefault();
            _state.updateState({isActiveBurgerMenu: !_state.isActiveBurgerMenu && !_state.isDesktop});
        })

        _utils.rebuildComponentsOnResize(() => {
            if(viewportChecker.mobDesk() && _state.isUserActive){
                _state.updateState({isActiveBurgerMenu: false});
            }
        });
    }
}

const mobileMenuDropdown = ()=> {
    const mobileMenu = document.querySelector('.mobile-menu');
    const linksDropdown = mobileMenu.querySelectorAll('.mobile-menu__nav li.has-sub-menu')
    const mobileSubMenu = mobileMenu.querySelector('.mobile-menu__nav-submenu')
    const mobileSubMenuBackBtns = mobileSubMenu.querySelectorAll('.mobile-menu__nav-submenu-back-btn')

    linksDropdown?.forEach(link=> {
        link.addEventListener('click',(e)=> {
            e.preventDefault();
            const dataKeyId = link.getAttribute('data-key');
            const dataKeyIdTarget = mobileSubMenu.querySelector('#'+dataKeyId);
            mobileSubMenu.classList.add('open');
            mobileMenu?.classList.add('sub-menu-opened');
            dataKeyIdTarget?.classList.add('active');
        })
    })

    mobileSubMenuBackBtns?.forEach(backBtn=> {
        backBtn?.addEventListener('click',(e)=> {
            mobileSubMenu.classList.remove('open');
            mobileMenu?.classList.remove('sub-menu-opened');
            mobileSubMenu.querySelectorAll('.mobile-menu__nav-submenu-item')?.forEach(li=> {
                li.classList.remove('active')
            })
        })
    })

}

const mobileMenuLinks = ()=> {
    const mobileMenu = document.querySelector('.mobile-menu');
    const links = mobileMenu.querySelectorAll('a')

    links?.forEach(link=> {
        link.addEventListener('click',(e)=> {
            _state.updateState({isActiveBurgerMenu: false});
        })
    })
}


